export default {
  costStatus:{
    "manager":"manager",
    "accounting":"accounting",
    "accountingCancel":"accountingCancel",
    "waiting":"waiting",
    "rejectedByManager":"rejectedByManager",
    "costCompleted":"costCompleted."
  },
  costFields:{
    "supplierName":"supplierName",
    "paymentType":"paymentType",
    "moneyType": "currencyUnit",
    "invoiceNo":"invoiceNo",
    "costType":"costType",
    "costDescription":"costDescription",
    "costDate":"costDate",
    "costAmount":"costAmount",
    "kdvOrani":"vatRate",
    "deletedPhotoId": "costPhoto",
    "costPhoto": "costPhoto",
    //SPEACIAL FIELDS FOR SUMIAGRO
    formType: "costFormType",
    actualExpenditureCostAmount: "actualExpenditure",
    companyName: "company",
    placeName: "place",
    guestName: "guests",
    guestNumber: "guestNumber",
    staffName: "staffName",
    staffNumber: "staffNumber",
    otherParticipant: "otherParticipants",
    otherParticipantNumber: "otherParticipantNumber",
  },
};
